module.exports = __webpack_public_path__ + "static/olx.987b3bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/olx.png
// module id = 625
// module chunks = 35783957827783